import React, { Component, Children, PropTypes } from 'react';
import classes from './DeliverySummary.css';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

class DeliverySummary extends Component {
    componentDidMount() {
    }

    sendDelivery =() => {
        this.props.sendDelivery(this.props.delivery.deliveryId);
    }

    changeDriver = () => {
        this.props.changeDriver();
    }

    render() {
        let driver = null
        let driverName = 'not set';
        let bags = 0;
        let totals = '';
        let spacer = '';
        let submit = "";
        if (this.props.delivery) {
            if (this.props.delivery.driverId > 0) {
                for (let l in this.props.drivers) {
                    if (this.props.drivers[l].driverId == this.props.delivery.driverId) {
                        driver = this.props.drivers[l];
                        driverName = driver.firstName + ' ' + driver.lastName;
                        bags = driver.numberOfBags;
                    }
                }
            }

            if (this.props.delivery.hardwoodBags > 0) {
                totals = 'Hardwood:' + this.props.delivery.hardwoodBags;
                spacer = '  ';
            }
            if (this.props.delivery.cedarBags > 0) {
                totals = totals + spacer + 'Cedar:' + this.props.delivery.cedarBags;
                spacer = '  ';
            }
            if (this.props.delivery.blackBags > 0) {
                totals = totals + spacer + 'Black:' + this.props.delivery.blackBags;
                spacer = '  ';
            }
            if (this.props.delivery.redBags > 0) {
                totals = totals + spacer + 'Red:' + this.props.delivery.redBags;
                spacer = '  ';
            }

            let totalBags = this.props.delivery.hardwoodBags + this.props.delivery.cedarBags + this.props.delivery.blackBags + this.props.delivery.redBags;
            totals = totals + spacer + "TOTAL NUMBER OF BAGS: " + totalBags;

            if (this.props.delivery.status == 'initial' && this.props.delivery.driverId > 0) {
                submit = <a onClick={this.sendDelivery}>SEND TO LOAD</a>;
            }
        }
        else {
            totals = "";
        }
        
        if (this.props.delivery && this.props.delivery.deliveryId) {
            return (
                <div className={classes.DeliverySummary}>
                    <span>Delivery: {this.props.delivery.deliveryId} Driver: {driverName} (max {bags} bags) <a onClick={this.changeDriver}>Change</a>  {totals}   {submit}</span>
                </div>
            );
        }
        else {
            return (
                <div className={classes.DeliverySummary}>
                    <span>Driver: {driverName} (max {bags} bags) <a onClick={this.changeDriver}>Change</a>  {totals}   {submit}</span>
                </div>
            );
        }
    }
}

const mapStateToProps = state => {
    return {
        delivery: state.orders.delivery,
        drivers: state.orders.drivers
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchDeliveryDrivers: () => dispatch(actions.getDrivers()),
        sendDelivery : (deliveryId) => dispatch(actions.sendDeliveryToLoad(deliveryId)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(DeliverySummary);


// WEBPACK FOOTER //
// ./src/components/DeliverySummary/DeliverySummary.js